import React, { useEffect, useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { FiShoppingCart } from "react-icons/fi";
import { BsChatLeft } from "react-icons/bs";
import { RiNotification3Line } from "react-icons/ri";
import { MdKeyboardArrowDown } from "react-icons/md";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

import avatar from "../data/avatar.jpg";
import { Cart, Chat, Notification, UserProfile } from ".";
import { useStateContext } from "../contexts/ContextProvider";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 end-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = (parms) => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    handleClick,
    isClicked,
    setScreenSize,
    screenSize,
  } = useStateContext();

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);
  const profile = parms.profile

  return (
    <div className="flex justify-between p-2 md:ml-6 md:mr-6 relative">
      {(profile.permissions && (!profile.permissions.includes(0) && !profile.permissions.includes(1) && !profile.permissions.includes(2) && !profile.permissions.includes(5) && !profile.permissions.includes(6) && !profile.permissions.includes(7) && !profile.permissions.includes(8))) && <AwaitingApproval/>}
      <NavButton
        title="Menu"
        customFunc={handleActiveMenu}
        color={currentColor}
        icon={<AiOutlineMenu />}
      />
      <div className="flex">
        <TooltipComponent content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick("userProfile")}
          >
            <p>
              <span className="text-gray-400 text-14">سلام,</span>{" "}
              <span className="text-gray-400 font-bold ml-1 text-14">
                {profile.firstName + " " + profile.lastName}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </TooltipComponent>

 
        {isClicked.userProfile && <UserProfile />}
      </div>
    </div>
  );
};

function AwaitingApproval() {

  function refresh() {
    window.location.reload();
  }
  function home() {
    window.location.replace('https://kafil.liara.run')
  }

  return(<div style={{backgroundColor: "white", position: "fixed", top: "0", left: "0", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", zIndex: "1", flexDirection: "column", gap: "40px"}}>
    <div style={{maxWidth: "150px", marginBottom: "-20px"}}>
      <img src="logo.png" alt="" />
    </div>
    <p style={{fontSize: "34px", maxWidth: "800px", textAlign: "center"}}>ثبت نام شما با موفقیت انجام شده و در انتظار تایید دسترسی توسط مدیر سیستم است.</p>
    <div style={{display: "flex", gap: "20px"}}>
      <button style={{width: "170px", height: "45px", borderRadius: "25px", color: "white", backgroundColor: "#1a5319"}} onClick={home}>برو به صفحه اصلی</button>
      <button style={{width: "170px", height: "45px", borderRadius: "25px", border: "1px solid #aaa"}} onClick={refresh}>بارگزاری مجدد</button>
    </div>
  </div>)
}

export default Navbar;
